import { SecureAxios } from './Axios';
import { API_ROOT } from './Constants';
const CacheKey = 'noFlyZones';
const BASE_PATH = `${API_ROOT}/noFlyZones`;
const PATHS = {
    CREATE: BASE_PATH,
    DELETE: (noFlyZoneId) => `${BASE_PATH}/${noFlyZoneId}`,
    GET: (noFlyZoneId) => `${BASE_PATH}/${noFlyZoneId}`,
    LIST: BASE_PATH,
    UPDATE: (noFlyZoneId) => `${BASE_PATH}/${noFlyZoneId}`,
};
async function create(csrfToken, props) {
    return (await (await SecureAxios()).post(PATHS.CREATE, { ...props }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function delete_(csrfToken, noFlyZoneId) {
    return (await (await SecureAxios()).delete(PATHS.DELETE(noFlyZoneId), { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function get(noFlyZoneId) {
    return (await (await SecureAxios()).get(PATHS.GET(noFlyZoneId))).data;
}
function getKey(noFlyZoneId) {
    return [CacheKey, 'get', noFlyZoneId];
}
async function list(props) {
    const params = new URLSearchParams();
    if (props.limit)
        params.append('limit', props.limit.toString());
    if (props.offset)
        params.append('offset', props.offset.toString());
    if (props.orderBy)
        params.append('orderBy', props.orderBy);
    if (props.order)
        params.append('order', props.order);
    if (props.query)
        params.append('q', props.query);
    if (props.latitude)
        params.append('latitude', props.latitude.toString());
    if (props.longitude)
        params.append('longitude', props.longitude.toString());
    if (props.radius)
        params.append('radius', props.radius.toString());
    return (await (await SecureAxios()).get(`${PATHS.LIST}?${params.toString()}`)).data;
}
function listKey(props) {
    return [CacheKey, 'list', props];
}
async function update(csrfToken, noFlyZoneId, props) {
    return (await (await SecureAxios()).put(PATHS.UPDATE(noFlyZoneId), { ...props }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
export default { CacheKey, create, delete_, get, getKey, list, listKey, update };
